import React from 'react';
import { useReactTable, getCoreRowModel, flexRender, getPaginationRowModel } from '@tanstack/react-table';
import CaretRight from '../assets/icons/CaretRight';
import CaretLeft from '../assets/icons/CaretLeft';
import './ReactTable.css';
import { generatePageNumbers } from '../utils/helpers';
const ReactTable = (props) => {

    let { columns, data, actionMenu, setSelectedRow, pageCount, paginationState, totalRecords } = props;

    const handleMenuClick = (event, row) => {
        event.stopPropagation();
        setSelectedRow(row.original);
    }
    // Add a new column for the action button
    if (actionMenu?.length) {
        columns = [
            ...columns,
            {
                header: 'Actions',
                id: 'actions',
                className: 'text-end',
                cell: ({ row }) => (
                    <div className='d-flex'>
                        {actionMenu.map((menu, index) => (
                            <div key={`${row.original.id}-${index}`}
                                className='icons'
                                onClick={(e) => {
                                    handleMenuClick(e, row);
                                    menu.action(row);
                                }}>
                                {menu.icon}
                            </div>
                        ))
                        }
                    </div >
                ),
            }
        ]
    }

    const tableOptions = {
        columns,
        data,
        getCoreRowModel: getCoreRowModel(),
        state: {},
    };

    if (pageCount && paginationState) {
        tableOptions.getPaginationRowModel = getPaginationRowModel();
        tableOptions.onPaginationChange = paginationState.setPagination;
        tableOptions.state.pagination = paginationState.pagination;
        tableOptions.pageCount = pageCount;
        tableOptions.manualPagination = true;
    }

    const table = useReactTable(tableOptions);

    const currentPage = paginationState?.pagination?.pageIndex ?? 0;
    const pageSize = paginationState?.pagination?.pageSize ?? 10;

    const from = totalRecords === 0 ? 0 : currentPage * pageSize + 1;
    const to = Math.min((currentPage + 1) * pageSize, totalRecords);

    return (
        <>
            <div className="table-container">
                <table className="custom-table">
                    <thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => (
                                    <th key={header.id}>
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.length > 0 ? (
                            <>
                                {table.getRowModel().rows.map((row) => (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map(cell => (
                                            <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                                        ))}
                                    </tr>
                                ))}
                            </>
                        ) : (
                            <tr className='table__body--row'>
                                <td colSpan={columns.length} style={{ textAlign: 'center' }}>
                                    No Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className='pagination-section'>
                {totalRecords > 0 && (
                    <div className="pagination-summary">
                        <span>
                            Showing {from} to {to} of {totalRecords} entries
                        </span>
                    </div>
                )}

                {pageCount !== 0 && paginationState && (
                    <div className="pagination">
                        <button
                            onClick={() => table.previousPage()}
                            disabled={!table.getCanPreviousPage()}>
                            <CaretLeft size={14} />
                        </button>
                        {generatePageNumbers(table).map((pageNumber, index) => (
                            <button
                                key={index}
                                onClick={() => typeof pageNumber === 'number' && table.setPageIndex(pageNumber - 1)}
                                className={`pagination_btn ${pageNumber === table.getState().pagination.pageIndex + 1 ? 'active' : ''}`}
                                disabled={typeof pageNumber !== 'number'}
                            >
                                {pageNumber}
                            </button>
                        ))}
                        <button
                            onClick={() => table.nextPage()}
                            disabled={!table.getCanNextPage()}>
                            <CaretRight size={14} />
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default ReactTable;
